import FAQSubCategory from '../models/FAQSubCategory'
import FAQArticleMapper from './FAQArticle.mapper';
export default class FAQSubCategoryMapper {
    public map(data: any) : FAQSubCategory {
        const faqSubCategory : FAQSubCategory = new FAQSubCategory();
        faqSubCategory.title = data.Title;
        faqSubCategory.articles = data.Articles.map((art : any) => new FAQArticleMapper().map(art));
        return faqSubCategory;
    }
}